import { useCallback } from 'react';
import { useNavigation } from './useNavigation.ts';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { RootState } from '../store/rootReducer';
import { resetPhotoState } from '../store/photoSlice';
import { setPaid } from '../store/authSlice';
import { resetTheme } from '../store/themeSlice';

export const useTimeoutHandler = () => {
  const { navigateToStart, navigateToPayment, navigateToShot, navigateToStandby } = useNavigation();
  const dispatch = useDispatch();

  const { photoCount, allowQrcode, selectedThemeId, block } = useSelector(
    (state: RootState) => ({
      photoCount: state.photo.photoCount,
      allowQrcode: state.photo.allowQrcode,
      selectedThemeId: state.theme.selectedThemeId,
      block: state.block.block,
    }),
    shallowEqual
  );

  const selectedTheme = selectedThemeId
    ? block?.themes.find((t) => t.id === selectedThemeId) || block?.themes[0]
    : block?.themes[0];
  const inAppPay = selectedTheme?.inAppPay || false;

  const handleThemeTimeout = useCallback(() => {
    dispatch(resetTheme());
    navigateToStart();
  }, [navigateToStart]);

  const handleCopyTimeout = useCallback(() => {
    if (photoCount === 0 && !allowQrcode) {
      navigateToStart();
    } else {
      if (!inAppPay) {
        navigateToStandby();
      } else {
        navigateToPayment();
      }
    }
  }, [navigateToStart, navigateToPayment, navigateToStandby, photoCount, allowQrcode, inAppPay]);

  const handleStandbyTimeout = useCallback(() => {
    navigateToShot();
  }, [navigateToShot]);

  const handlePrintTimeout = useCallback(() => {
    navigateToStart();
    setTimeout(() => {
      dispatch(resetPhotoState());
      localStorage.removeItem('isPaid');
      dispatch(setPaid(false));
    }, 100);
  }, [navigateToStart, dispatch]);

  return {
    handleThemeTimeout,
    handleCopyTimeout,
    handleStandbyTimeout,
    handlePrintTimeout,
  };
};
